import { render } from "./DirectionSelection.vue?vue&type=template&id=048ca708&scoped=true"
import script from "./DirectionSelection.vue?vue&type=script&lang=js"
export * from "./DirectionSelection.vue?vue&type=script&lang=js"

import "./DirectionSelection.vue?vue&type=style&index=0&id=048ca708&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048ca708"]])

export default __exports__